function handleVariantButtonClick(event) {
  event.preventDefault();

  const variantId = event.target.getAttribute("data-variant-id");
  const variantPrice = event.target.getAttribute("data-variant-price");
  const variantComparePrice = event.target.getAttribute(
    "data-variant-compare-price"
  );
  const variantOnSale = event.target.getAttribute("data-variant-onsale");
  const variantImage = event.target.getAttribute("data-variant-image");
  const productId = event.target.getAttribute("data-product-id");
  const jumboVariantId = event.target.getAttribute("data-jumbo-variant-id");
  const jumboDiscount = event.target.getAttribute("data-jumbo-discount");

  document.querySelector(`#product-data-${productId} .feature-image`).src =
    variantImage;
  document.querySelector(`#product-data-${productId} .secondary-image`).src =
    variantImage;

  const jumboBubble = document.querySelector(
    `#product-data-${productId} .jumbo-bubble`
  ).classList;

  //   console.log("Variant ID: ", variantId);
  //   console.log("Jumbo Variant ID: ", jumboVariantId);
  //   console.log("Equal", variantId === jumboVariantId);

  if (variantId === jumboVariantId && jumboDiscount > 0) {
    document.querySelector(
      `#product-data-${productId} .jumbo-amount`
    ).innerHTML = jumboDiscount;
    jumboBubble.remove("x-hidden");
  } else {
    jumboBubble.add("x-hidden");
  }

  if (variantOnSale == "true") {
    document.querySelector(
      `#product-data-${productId} .product-price .full-price`
    ).innerHTML = variantComparePrice;
    document.querySelector(
      `#product-data-${productId} .product-price .compare-price`
    ).innerHTML = variantPrice;
    document
      .querySelector(`#product-data-${productId} .product-price .full-price`)
      .classList.add("x-text-[#5E93DB]");
    document
      .querySelector(`#product-data-${productId} .product-price s`)
      .classList.remove("hidden");
  } else {
    document.querySelector(
      `#product-data-${productId} .product-price .full-price`
    ).innerHTML = variantPrice;
    document
      .querySelector(`#product-data-${productId} .product-price .full-price`)
      .classList.remove("x-text-[#5E93DB]");
    document
      .querySelector(`#product-data-${productId} .product-price s`)
      .classList.add("hidden");
  }

  // const shopButtons = document.querySelectorAll(`button#AddToCart`);
  // shopButtons.forEach((shopButton) => {
  // 	shopButton.classList.add('x-opacity-0');
  // });

  const cardContainers = document.querySelectorAll(`.card-container`);
  cardContainers.forEach((cardContainer) => {
    cardContainer.classList.remove("product-card-shadow");
  });
  document
    .querySelector(`#product-data-${productId}.card-container`)
    .classList.add("product-card-shadow");

  // document.querySelector(`#product-data-${productId} button#AddToCart`).classList.remove('x-opacity-0');
  // document.querySelector(`#product-data-${productId} button#AddToCart`).classList.add('x-opacity-100');

  const variantButtons = document.querySelectorAll(
    `#product-data-${productId} .variant-button`
  );
  variantButtons.forEach((variantButton) => {
    variantButton.classList.remove("selected-variant");
  });

  document.getElementById(`product-select-${productId}`).value = variantId;
  document
    .querySelector(`[data-variant-id="${variantId}"].variant-button`)
    .classList.add("selected-variant");
}
